import { Component, OnInit, Input, OnDestroy, AfterViewInit, ViewChild, ElementRef, NO_ERRORS_SCHEMA } from '@angular/core';
import { User } from '../../_models/user';
import { Empresa } from '../../_models';
import { Router, RouterModule } from '@angular/router';
import { AuthenticationService, DocumentService, MenuService } from '../../_services';
import { EmpresaService } from '../../_services';
import { SolrService } from '../../solr/solr.service';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ElementService } from '../../_services/element.service';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../logo/logo.component';
import { FormsModule } from '@angular/forms';
import { ComponentLoaderComponent } from '../component-loader/component-loader.component';
import { FilterComponent } from '../../solr/filter/filter.component';
import { MetadataFilterComponent } from '../../solr/metadata-filter/metadata-filter.component';
import { CalendarFilterComponent } from '../../solr/calendar-filter/calendar-filter.component';
import { environment } from '../../../environments/environment';

// Declare jQuery for TypeScript
declare var $: any;
declare var jQuery: any;


@Component({
  standalone:true,
  schemas:[NO_ERRORS_SCHEMA],
  selector: "app-menu-aside",
  styleUrls: ["./menu-aside.component.scss"],
  templateUrl: "./menu-aside.component.html",
  imports: [CommonModule, LogoComponent, FormsModule, ComponentLoaderComponent, RouterModule, FilterComponent, MetadataFilterComponent, CalendarFilterComponent]
})
export class MenuAsideComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('asideMenu', {static: false}) asideMenu!: ElementRef;
  private checkJQueryStatus(): void {
    console.log('=== jQuery Status Check ===');
    console.log('typeof $:', typeof $);
    console.log('typeof jQuery:', typeof jQuery);
    console.log('window.$:', !!((window as any)['$']));
    console.log('window.jQuery:', !!((window as any)['jQuery']));
    
    if(typeof $ !== 'undefined') {
      console.log('jQuery version:', $.fn.jquery);
      console.log('jQuery.fn.extend available:', typeof $.fn.extend);
    }
  }
  ngAfterViewInit() {
  }
  
  public currentUrl: string = '';
  public currentUser: User = new User();
  public loadingMenu: boolean = false;
  // "Desenvolvido por": mesma flag do login (showDevelopedBy no environment)
  public showDevelopedBy = !!(environment as { showDevelopedBy?: boolean }).showDevelopedBy;
  public empresas_id: any[] = [];
  public empresas: any[] = [];
  public selectedEmpresas: any[] = [];
  public completeQuery: string = '';
  public searchText: any = null;
  public exactSearchEnabled = (localStorage.getItem('exactSearchEnabled') || 'false') === 'true';
  private countDocSubscription: any = null;
  private numPendingDocsSubscription: any = null;
  private numStatusSupportSubscription: any = null;
  private useReviewQuerySubscription: any = null;
  private useStatusSupportQuerySubscription: any = null;
  private getCurrentStatusSupportQuerySubscription: any = null;
  public documents: Document[] = [];
  public valData: any = {};
  public countEmpresa: number = 0;
  public defaultEmpresas: any[] = [];
  public arrayEmpresas: any[] = [];
  public noSubitems = null;
  allDeslected: boolean = false;
  selectAll = true;
  filtroPendente = false;
  filtroStatusSupport = false;
  textSelect = "Desselecionar";
pendentes: any;
statusSupport: any;
  showLegadoButton = false;
  @Input() links: Array<any> = [];
  @Input() display_menu_user = true;
  @Input() display_menu_search = true;
  @Input() docInput!: Document;
  backupLinks: Array<any> = [];
  private docObservable = new Observable((observer) => {
    observer.next("doc");
    observer.complete();
  });
  treeviewOpen = false;
  
   menuSubscription: Subscription | undefined;
  constructor(
    private authService: AuthenticationService,
    private empresaService: EmpresaService,
    public router: Router,
    private documentService: DocumentService,
    public solrService: SolrService,
    private menuServ: MenuService,
    public translate: TranslateService,
    public elementService: ElementService
  ) {
    let storelang = localStorage.getItem("lang") || 'pt';
    this.translate.use(storelang);

    // getting the current url
    this.router.events.subscribe((evt: any) => (this.currentUrl = evt.url));
    this.currentUser = this.authService.currentUserValue;
  }

  openCloseTreeview(event: any) {
    this.treeviewOpen = !this.treeviewOpen;
    if(this.treeviewOpen) {
      event.currentTarget.className = "nav-item menu-is-opening menu-open"
      return
    }
    event.currentTarget.className = "nav-item"
  }

  hashCode(s: any) {
    let h = 0;
    let l = s.length, i = 0;
    if(l > 0) {
      while(i < l) {
        // tslint:disable-next-line: no-bitwise
        h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
      }
    }
    return h;
  }
  private createDictCount(data: any) {
    const dictCount: { [key: string]: any } = {};
    let key = "";
    data.facet_counts.facet_fields.client_id.forEach((element: any) => {
      if(typeof element === 'number') {
        dictCount[key] = element;
      } else {
        key = element;
      }
    });
    return dictCount;
  }
  public ngOnInit() {
    this.empresas = this.currentUser.empresas;
    this.defaultEmpresas = this.empresas;

    this.loadSubscription();
    if(this.currentUser.masterAdmin || this.currentUser.isAdmin) {
      this.translateItems(this.menuServ.globalMenuConfigAdmin);
      this.menuServ.setCurrent(this.menuServ.globalMenuConfigAdmin)
    } else if(this.currentUser.profileRevisor || this.currentUser.profileViewRevisor) {
      this.translateItems(this.menuServ.globalMenuConfigRevisor);
      this.menuServ.setCurrent(this.menuServ.globalMenuConfigRevisor)
    } else{
      this.translateItems(this.menuServ.globalMenuConfigAdmin);
      this.menuServ.setCurrent(this.menuServ.globalMenuConfigAdmin)
    }
  }

  translateItems(items: any[]) {
    items.forEach((box: any) => {
      if(box.header) {
        const translatedName = this.translate.instant(box.header.toLowerCase());
        if (box.header.toLowerCase() === translatedName) {
          console.log(`Não há tradução disponível para: ${box.header}`);
        } else {
          box.header = translatedName;
        }
      }

      if(box.title) {
        const translatedName = this.translate.instant(box.title.toLowerCase());
        if (box.title.toLowerCase() === translatedName) {
          console.log(`Não há tradução disponível para: ${box.title}`);
        } else {
          box.title = translatedName;
        }
      }

      if(box.subitems) {
        box.subitems.forEach((subitems: any) => {
          if(subitems.title) {
            const translatedName = this.translate.instant(subitems.title.toLowerCase());
            if (subitems.title.toLowerCase() === translatedName) {
              console.log(`Não há tradução disponível para: ${subitems.title}`);
            } else {
              subitems.title = translatedName;
            }
          }
        });
      }

    });
  }

  loadSubscription() {
    this.menuSubscription = this.menuServ.getCurrent().subscribe((menu: any) => {
      this.links = menu;
    });
    this.empresaService.getShowButtonsLegago().subscribe((showButton: any) =>{
      
      this.showLegadoButton = showButton;
      if(!showButton) {
        this.backupLinks = this.links;
        this.links = this.links.filter((data: any) =>['Revisão','Documentos','Processamentos'].indexOf(data.title)==-1);
      }else if(this.backupLinks.length > 0) {
        this.links = this.backupLinks;
      }
    })
    this.numPendingDocsSubscription = this.solrService
      .getCurrentNumPendingDocs()
      .subscribe((data: any) => {
        this.pendentes = data;
      });
    this.numStatusSupportSubscription = this.solrService
      .getCurrentNumStatusSupportDocs()
      .subscribe((data: any) => {
        this.statusSupport = data;
      });

    this.useReviewQuerySubscription = this.solrService
      .getUseIsReviewQuery()
      .subscribe((data: any) => {
        this.filtroPendente = data;
        this.solrService.updatePendentesQuery(this.filtroPendente);
      });
    this.useStatusSupportQuerySubscription = this.solrService
      .getUseStatusSupportQuery()
      .subscribe((data: any) => {
        this.filtroStatusSupport = data;
        this.solrService.updateStatusSupportQuery(this.filtroStatusSupport);
      });
    this.getCurrentStatusSupportQuerySubscription = this.solrService
      .getCurrentStatusSupportQuery()
      .subscribe((query: any) => {
        if(this.solrService.solrCore=='docs-ia') {
          this.solrService.getStatusSupportDocs(query).subscribe((data: any) => {
            // console.log('getSolrData return...');
            this.solrService.setCurrentNumStatusSupportDocs(
              data.response.numFound
            );
          });
        }
      });
  }

  selectEmpresa(empresa: Empresa) {
    this.arrayEmpresas = this.selectedEmpresas.filter((data: Empresa) => {
      return data.checked === true;
    });
    // this.solrService.sethFirstTimeFilter(true);
    this.solrService.applyEmpresaFilter(this.selectedEmpresas, true);
  }

  selectAllEmpresa() {
    if(this.selectAll) {
      this.selectedEmpresas.forEach((empresa: Empresa) => {
        empresa.checked = false;
        this.textSelect = "Selecionar";
      });
      this.selectAll = !this.selectAll;
    } else {
      this.selectedEmpresas.forEach((empresa: Empresa) => {
        empresa.checked = true;
        this.textSelect = "Desselecionar";
      });
      this.selectAll = !this.selectAll;
    }
    this.arrayEmpresas = this.selectedEmpresas.filter((data: Empresa) => {
      return data.checked === true;
    });
    this.solrService.applyEmpresaFilter(this.arrayEmpresas, true);
  }

  getSearch(search: any) {
    this.solrService.setSearch(search, this.exactSearchEnabled);
  }

  toggleExactSearchEnabled() {
    this.exactSearchEnabled = !this.exactSearchEnabled;
    localStorage.setItem(
      "exactSearchEnabled",
      this.exactSearchEnabled.toString()
    );
  }

  setPendenteValor(filtroPendente: any) {
    this.solrService.setUseIsReviewQuery(filtroPendente);
  }
  setStatusSupportValor(filtroStatusSupport: any) {
    this.solrService.setUseStatusSupportQuery(filtroStatusSupport);
  }

  openModal(valdata: any) {
    this.documentService.setCurrentModalValidation(valdata);
  }

  ngOnDestroy(): void {
    if(this.countDocSubscription) {
      this.countDocSubscription.unsubscribe();
    }
    if(this.numPendingDocsSubscription) {
      this.numPendingDocsSubscription.unsubscribe();
    }
    if(this.numStatusSupportSubscription) {
      this.numStatusSupportSubscription.unsubscribe();
    }
    if(this.useReviewQuerySubscription) {
      this.useReviewQuerySubscription.unsubscribe();
    }
    if(this.useStatusSupportQuerySubscription) {
      this.useStatusSupportQuerySubscription.unsubscribe();
    }
    if(this.getCurrentStatusSupportQuerySubscription) {
      this.getCurrentStatusSupportQuerySubscription.unsubscribe();
    }
    if(this.useReviewQuerySubscription) {
      this.useReviewQuerySubscription.unsubscribe();
    }
    if(this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }
}
